import axios from 'axios';
import apiConfig from '../pages/Configuracion/apiConfig';
import tokenStorage from './tokenStorage';

export const authService = {

  RegisterUserApi: async (data) => {
    try {
      const response = await axios.post(apiConfig.RegisterUserApi, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
   },

   login: async ({ identificationNumber, email, password }) => {
    try {
      const { data } = await axios.post(apiConfig.Login, {
        identificationNumber,
        email,
        password
      });
      return data;
    } catch (error) { // ✅ AJUSTE: Corregir sintaxis del catch
      throw error.response?.data || error;
    }
  }, // ✅ AJUSTE: Agregar coma faltante

  verifyOtp: async ({ identificationNumber, otp, email, ip }) => {
    try {
      const { data } = await axios.post(apiConfig.VerifyOtp, {
        identificationNumber,
        otp,
        email,
        ip
      });
      
      // ALMACENAR TOKEN Y DATOS DESPUÉS DE VERIFICACIÓN EXITOSA
      if (data?.statusCode === 200 || data?.token) {
        console.log(' Almacenando datos de autenticación...');
        
        // Almacenar token
        if (data.token) {
          tokenStorage.setToken(data.token);
          console.log(' Token almacenado');
        }
        
        // ✅ AJUSTE: Definir userData que faltaba
        const userData = data.user || data.userData || {};
        const userToStore = {
          name: userData.name || userData.fullName || `Usuario ${identificationNumber}`,
          email: email,
          identificationNumber: identificationNumber,
          role: userData.role || userData.userRole || 'Usuario'
        };
        
        tokenStorage.setUserData(userToStore);
        console.log(' Datos de usuario almacenados:', userToStore);
        
        console.log(' Autenticación completa almacenada');
      }

      return data;
    } catch (error) { // ✅ AJUSTE: Agregar catch que faltaba
      throw error.response?.data || error;
    }
  }, // ✅ AJUSTE: Agregar coma faltante

  // MÉTODO DE CAMBIO DE CONTRASEÑA CON TOKEN
  changePassword: async ({ currentPassword, newPassword, identificationNumber }) => {
    try {
      const token = tokenStorage.getToken();
      
      if (!token) {
        throw new Error('No hay token de autenticación. Inicia sesión nuevamente.');
      }
      
      console.log(' Enviando solicitud de cambio de contraseña...');
      
      const payload = {
        currentPassword,
        newPassword,
        identificationNumber
      };
      
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      };
      
      const { data } = await axios.post(apiConfig.ChangePassword, payload, config);
      
      console.log(' Contraseña cambiada exitosamente');
      return data;
    } catch (error) {
      console.error(' Error al cambiar contraseña:', error);
      throw error.response?.data || error;
    }
  },

  // MÉTODO DE RECUPERACIÓN DE CONTRASEÑA 
  recoverPassword: async ({ email, identificationNumber }) => {
    try {
      console.log(' Enviando solicitud de recuperación de contraseña...');
      
      const payload = {
        email: email.trim(),
        identificationNumber: identificationNumber.toString().trim()
      };
      
      const { data } = await axios.post(apiConfig.RecoverPassword, payload);
      
      console.log(' Solicitud de recuperación enviada');
      return data;
    } catch (error) {
      console.error(' Error en recuperación de contraseña:', error);
      throw error.response?.data || error;
    }
  },

  // MÉTODO PARA CERRAR SESIÓN
  logout: () => {
    console.log(' Cerrando sesión...');
    tokenStorage.clearAll();
    console.log(' Sesión cerrada');
  },

  // MÉTODO PARA VERIFICAR SI ESTÁ AUTENTICADO
  isAuthenticated: () => {
    return tokenStorage.isAuthenticated();
  },

  // MÉTODO PARA OBTENER DATOS DEL USUARIO ACTUAL
  getCurrentUser: () => {
    return tokenStorage.getUserData();
  }
};

// INTERCEPTOR PARA AGREGAR TOKEN AUTOMÁTICAMENTE A TODAS LAS PETICIONES
axios.interceptors.request.use(
  (config) => {
    const token = tokenStorage.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// INTERCEPTOR PARA MANEJAR ERRORES DE AUTENTICACIÓN
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log(' Token expirado o inválido, cerrando sesión...');
      tokenStorage.clearAll();
      window.location.reload(); // Recargar para volver al login
    }
    return Promise.reject(error);
  }
);

export default authService;
export const tokenStore = {
  get: () => localStorage.getItem("token"),
  set: (token) => localStorage.setItem("token", token),
  clear: () => localStorage.removeItem("token"),
};